const WireTransferDashboardStyle = {
	
};

export default WireTransferDashboardStyle;
